/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useDnD } from './dndContext';
import CircleIcon from '@mui/icons-material/Circle';
import { IconWithTooltip } from '../../../globalUtils/globalIcons';
import './Sidebar.css';


interface SidebarProps {
    nodes: Array<{ type: string }>;
    levelOfHeirarchy: string;
}
const Sidebar: React.FC<SidebarProps> = ({ nodes, levelOfHeirarchy }) => {
    const [_, setType] = useDnD();
    // // Check if a Trigger node exists
    // const hasTrigger = nodes.some((node) => (node.type === 'parameter' || node.type === 'alarm' || node.type === 'scheduler'));

    // // Check if a Flow node (e.g., 'then', 'ifThen') exists
    // const hasFlow = nodes.some((node) => ['then', 'ifThen', 'ifThenElse'].includes(node.type));

    // Check if both a Trigger and Flow exist to disable further additions
    const disableTriggerSection = levelOfHeirarchy != 'trigger'
    const disableFlowSection =  levelOfHeirarchy != 'flow' && levelOfHeirarchy != 'disabled-then-flow' && levelOfHeirarchy != 'flow-or-action'
    const disableActionSection = levelOfHeirarchy != 'action' && levelOfHeirarchy != 'flow-or-action'
    const disableDelaySection = levelOfHeirarchy != 'disabled-then-flow'

    const disableThen = levelOfHeirarchy == 'disabled-then-flow' || levelOfHeirarchy == 'flow-or-action';

    const onDragStart = (event: React.DragEvent<HTMLDivElement>, nodeType: string) => {
        if (setType != null) {
            setType(nodeType);
        }
        event.dataTransfer.effectAllowed = 'move';

    };

    // Utility function to count occurrences of each type
    // const getNodeCount = (type) => nodes.filter(node => node.type === type).length;

    // Counts for specific nodes
    // const setParameterCount = getNodeCount('actionControlSetParameter');
    // const raiseTicketCount = getNodeCount('actionControlRaiseATicket');
    // const sendNotificationCount = getNodeCount('sendNotification');
    // const actionControlRemoteCommandCount = getNodeCount('actionControlRemoteCommand');
    // const disableSetParameter = setParameterCount >= 2;
    // const disableRaiseTicket = raiseTicketCount >= 2;
    // const disableSendNotification = sendNotificationCount >= 2;
    // const disableActionControlRemoteCommand = actionControlRemoteCommandCount >= 2;


    return (
        <aside className="advance_rule_engine_dndflow_sidebar">
            <div className="advance_rule_engine_dndflow_description">
                Drag & drop activity on the right panel for execution.
            </div>

            {/* Trigger Point Section */}
            <div className="advance_rule_engine_dndflow_sidebar_section">
                <div className='flexGap'>
                    <IconWithTooltip iconClassName={'trigger-point-sidebar'} />
                    <h4 className="section-title">
                        Trigger Points
                    </h4>
                </div>
                <div
                    className={`dndnode input ${disableTriggerSection ? 'disabled' : ''}`}
                    onDragStart={(event) => onDragStart(event, 'parameter')}
                    draggable
                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'define_execution__bolt_black__icon'} /> 
                    </div>
                    <span className={'node_text'}>
                        Trigger Point
                    </span>
                    <div style={{display:'flex',alignItems:'center'}}>
                        <IconWithTooltip iconClassName={'info-icon'} toolTipText={'Rule execution follows this logic, if the trigger point has one or more conditions based on System Info Parameter, Status Parameter, Setting Parameter, Alarm, Session Parameter, Derived Condition parameters.'}/>
                    </div>
                </div>
                <div
                    className={`dndnode input ${disableTriggerSection ? 'disabled' : ''}`}
                    onDragStart={(event) => onDragStart(event, 'scheduler')}
                    draggable

                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'circular-time-icon-black'} />
                    </div>
                    <span className={'node_text'}>

                        Schedule Time
                    </span>
                    <div style={{display:'flex',alignItems:'center'}}>
                        <IconWithTooltip iconClassName={'info-icon'} toolTipText={'Rule execution follows this logic, if the trigger condition persists only at the scheduled time (One-time or Recurring)'}/>
                    </div>
                </div>
            </div>

            {/* Flow Controls Section */}
            <div className={`advance_rule_engine_dndflow_sidebar_section ${disableFlowSection ? 'disabled' : ''}`}>
                <div className='flexGap'>
                    <CircleIcon fontSize='small' sx={{ color: '#8f8dff', fontSize: '14px' }} />
                    <h4 className="section-title">
                        Flow Controls
                    </h4>
                </div>
                {/* Dont need it now */}

                <div
                    className={`dndnode default ${disableThen ? 'disabled' : ''}`}
                    onDragStart={(event) => onDragStart(event, 'then')}
                    draggable

                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'action_control_cogs'} />
                    </div>
                    <span className={'node_text'}>

                        Then
                    </span>
                </div>
                <div
                    className="dndnode default"
                    onDragStart={(event) => onDragStart(event, 'ifThen')}
                    draggable

                >
                    <div className="custom-margin">

                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'action_control_cogs'} />

                    </div>
                    <span className={'node_text'}>
                        If - Then
                    </span>
                </div>
                <div
                    className="dndnode default"
                    onDragStart={(event) => onDragStart(event, 'ifThenElse')}
                    draggable={!disableFlowSection}>
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'action_control_cogs'} />
                    </div>
                    <span className={'node_text'}>

                        If - Then - Else
                    </span>
                </div>
                {/* <div
          className="dndnode default"
          onDragStart={(event) => onDragStart(event, 'thenElse')}
          draggable
              >
        <div className="custom-margin">   
        <IconWithTooltip iconClassName={'sidebar-handle'} />
        <IconWithTooltip iconClassName={'action_control_cogs'} />
          </div>
          <span className ={'node_text'}>

         Then - Else
          </span>
        </div> */}

            </div>

            {/* Action Controls Section */}
            <div className={`advance_rule_engine_dndflow_sidebar_section ${disableActionSection ? 'disabled' : ''}`}>
                <div className='flexGap'>
                    <CircleIcon fontSize='small' sx={{ color: '#0080DC', fontSize: '14px' }} />
                    <h4 className="section-title">
                        Action Controls
                    </h4>
                </div>

                {/* Set Parameter */}
                <div
                    className={'dndnode output'}
                    onDragStart={(event) => onDragStart(event, 'actionControlSetParameter')}
                    draggable
                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'set-parameter-sidebar'} />
                    </div>
                    <span className={'node_text'}>

                        Set Parameter
                    </span>
                </div>

                {/* Remote Command */}
                <div
                    className={'dndnode output'}
                    onDragStart={(event) => onDragStart(event, 'actionControlRemoteCommand')}
                    draggable
                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'remote-command-sidebar'} />
                    </div>
                    <span className={'node_text'}>
                        Remote Command
                    </span>
                </div>

                {/* Raise A Ticket */}
                <div
                    className={'dndnode output'}
                    onDragStart={(event) => onDragStart(event, 'actionControlRaiseATicket')}
                    draggable
                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'raise-a-ticket-sidebar'} />
                    </div>
                    <span className={'node_text'}>
                        Raise a Ticket
                    </span>
                </div>

                {/* Send notification */}
                <div
                    className={'dndnode output'}
                    onDragStart={(event) => onDragStart(event, 'sendNotification')}
                    draggable
                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'send-notification-sidebar'} />
                    </div>
                    <span className={'node_text'} style={{ marginLeft: '4px' }}>
                        Send Notification
                    </span>
                </div>

            </div>

            {/* Delays Control Section */}
            <div className={`advance_rule_engine_dndflow_sidebar_section ${disableDelaySection ? 'disabled' : ''}`}>

                <div className='flexGap'>
                    <CircleIcon fontSize='small' sx={{ color: '#DC6A00', fontSize: '14px' }} />
                    <h4 className="section-title">
                        Delays
                    </h4>
                </div>

                {/* Wait Block */}
                <div
                    className={'dndnode output'}
                    onDragStart={(event) => onDragStart(event, 'wait')}
                    draggable
                >
                    <div className="custom-margin">
                        <IconWithTooltip iconClassName={'sidebar-handle'} />
                        <IconWithTooltip iconClassName={'wait-node-sidebar'} />
                    </div>
                    <span className={'node_text'} style={{ marginLeft: '4px' }}>
                        Wait
                    </span>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;

